module.exports = __webpack_public_path__ + "static/media/01.2ce5b13c.png";